import React from "react";

export default class LoadingIndicator extends React.Component {
    public render(): JSX.Element {
        return (
            <div className="loading-indicator">
                <i className="fa fa-spinner fa-pulse fa-10x"></i>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator.tsx